import moment from "moment";

export default {
  methods: {
    calcNumOfDays(stats, type) {
      let dstr = null;
      let dend = null;
      let days = "NE";
      if (type === "str-end" && dstr !== "" && dend !== "") {
        dstr = moment(stats.dstr);
        dend = moment(stats.dend);
        days = moment.duration(dend.diff(dstr)).asDays();
      }
      return days.toString();
    },
    calcAvailHours(char, stats) {
      let days = this.calcNumOfDays(stats, "str-end");
      let factor = char.derate;
      let shiftDay = char.perday;
      let shiftDur = char.shift;
      let hrsAvail = null;

      days = days - char.free;
      hrsAvail = days * factor * shiftDur * shiftDay;
      hrsAvail = parseFloat(hrsAvail);
      hrsAvail = hrsAvail.toFixed(1);
      return hrsAvail.toString();
    }
  }
};
